<template>
  <div>
    <div class="rj-page-card__title" style="margin: 20px 0">
      申请资料上传(申请资料请加盖贵司公章)
      <span style="width: 30px;" @click="showTips">
        <i style="color: #2589ff;" class="el-icon-warning" />
      </span>
      <span class="required">*</span>
    </div>
    <div style="margin-top: 20px">
      <el-input
        v-model.trim="desc"
        style="width: 550px"
        maxlength="100"
        placeholder="请输入100字以内文字说明"
      />
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block; margin: 0 10px"
        :disabled="!desc.length"
        accept=".doc,.docx,.csv,.dot,.dwg,.gif,.jpe,.jpeg,.jpg,.pdf,.png,.pot,.pps,.pptx,.zip,.xlc,.xlm,.xls,.xlt,.xlw,.xlsx,.xlw,.txt,.rar,.eml"
        :before-upload="beforeUpload"
      >
        <el-button :disabled="!desc.length" type="primary">
          选择文件
        </el-button>
      </el-upload>
      支持扩展名：.rar .zip .doc .docx .pdf .jpg...
      <span style="color: red; margin-left: 10px">
        注：请先填写说明，才可选择文件。
      </span>
    </div>
    <ul class="el-upload-list el-upload-list--text" style="margin: 10px 0">
      <el-row :gutter="60">
        <el-col
          v-for="(item, index) in fileList"
          v-show="item.loading"
          :key="index"
          :span="9"
          class="el-col-auto"
        >
          <li tabindex="0" class="el-upload-list__item is-success">
            <a class="el-upload-list__item-name">
              <i class="el-icon-document" />
              {{ item.enclosureName }}
            </a>
            <label
              v-if="!item.loading"
              class="el-upload-list__item-status-label"
            >
              <i class="el-icon-upload-success el-icon-circle-check" />
            </label>
            <el-progress
              v-if="item.loading"
              style="margin-top: 5px"
              :percentage="item.percentage"
              :stroke-width="4"
              :show-text="false"
            />
          </li>
        </el-col>
      </el-row>
    </ul>
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column prop="attachmentName" label="文件名称" align="left">
        <template v-slot="{ row }">
          <el-button
            type="text"
            @click="openContract(row)"
          >
            {{ row.attachmentName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="上传人" align="left" />
      <el-table-column prop="createTime" label="上传时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left">
        <template v-slot="{ row, $index }">
          <el-popover v-model="row.removeVisible" width="160">
            <p style="line-height: 30px">
              确认删除该文件吗?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="row.removeVisible = false"
              >
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="removeFile($index)">
                确定
              </el-button>
            </div>
            <el-button slot="reference" type="text">
              删除
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 流程 -->
    <ApplyReminderDialog ref="applyReminderDialogRef" />
  </div>
</template>
<script type="es6">
import { getFileToken, downloadUrl } from '@/API/creditAxios.js';
import CreditFileAxios from '@/API/creditFileAxios';
import ApplyReminderDialog from './applyReminderDialog';
import store from '@/store';
import { parseTime } from '@/libs/util.js';

export default {
  data () {
    return {
      tableData: [],
      fileList: [],
      tableLoading: false,
      uploadUrl: '',
      downFileUrl: '',
      token: '',
      applicantReason: '', // 申请理由
      desc: ''
    };
  },
  components: {
    ApplyReminderDialog
  },
  methods: {
    initToken () {
      getFileToken().then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
        }
      }).catch(() => {

      });
    },
    showTips () {
      this.$refs.applyReminderDialogRef.openDialog();
    },
    checkSpecialCharacters (str) {
      // return str.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,\\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '');
      // 规则对象(flag)
      var flag = new RegExp("[`~!@#$^&*=|{}':;',\\[\\]<>《》/?~！@#￥……&*——|{}【】‘；：”“'。，、？]");
      // 判断 even 是否包含特殊字符
      if (flag.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    async uploadaction (upload) {
      if (this.checkSpecialCharacters(upload.file.name)) {
        this.$message.error('文件名中不能包含特殊字符！');
        return;
      }
      const fileNameSize = 1024 * 1024 * 300;
      if (upload.file.size > fileNameSize) {
        this.$message.error(`${upload.file.name} 文件大小不能超过300MB!`);
        return;
      }
      const form = new FormData(); // 创建form对象
      form.append('files', upload.file);
      const myfile = {
        enclosureName: upload.file.name,
        loading: true,
        percentage: 0
      };
      this.fileList.push(myfile);
      let user = await store.dispatch('getuser');
      CreditFileAxios.post(`${window._env_.CREDIT_FILE_SERVICE}/api/file/${window._env_.CREDIT_FILE_SERVICE_SYSTEMCODE}/${window._env_.CREDIT_FILE_SERVICE_POOLID}/${window._env_.CREDIT_FILE_SERVICE_CATALOGID}?Token=${this.token}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          myfile.percentage = (progressEvent.loaded / progressEvent.total * 100 | 0);
        }
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          myfile.loading = false;
          console.log(json.data[0], 1111);
          this.tableData.push({
            attachmentFileId: json.data[0].FID,
            attachmentName: json.data[0].FullName,
            attachmentType: 2,
            attachmentDesc: this.desc,
            createName: user.userName,
            createTime: parseTime(Date.now())
          });
          this.desc = '';
          this.$message.success(`文件“${upload.file.name}”,上传成功.`);
        } else {
          myfile.loading = false;
          this.$message.error(`文件“${upload.file.name}”,上传失败.`);
        }
      }).catch(() => {
        myfile.loading = false;
        this.$message.error(`文件“${upload.file.name}”,上传失败.`);
      });
    },
    beforeUpload (file) {
      const fileType = file.name.split('.').pop().toLowerCase(); // 获取文件后缀名
      const allowedTypes = ['doc', 'docx', 'csv', 'dot', 'dwg', 'gif', 'jpe', 'jpeg', 'jpg', 'pdf', 'png', 'pot', 'pps', 'pptx', 'zip', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'xlsx', 'xlw', 'txt', 'rar', 'eml']; // 允许的文件类型数组
      if (!allowedTypes.includes(fileType)) {
      // 文件类型不符合要求，阻止上传
        this.$message.error(`${file.name}文件类型不符合上传要求!`);
        return false;
      }
      // 文件类型符合要求，允许上传
      return true;
    },
    removeFile (index) {
      this.tableData.splice(index, 1);
    },
    openContract (row) {
      downloadUrl(row.attachmentFileId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data.replace('http://', 'https://'));
        }
      }).catch((res) => {
      });
    },
    setData (data) {
      this.tableData = data;
    }
  },
  mounted () {
    this.initToken();
  }
};
</script>
<style lang="scss" scoped>
:deep(.el-table){
  border: 1px solid #eef0f3;
  border-bottom: 0 !important;
}
:deep(.el-table th){
  border-right: 0 !important;
}
</style>
